import React from 'react'
import { LocaleContext } from '@cbgms/base/locale/LocaleContext'
import Dropdown from '@cbgms/components/form/Dropdown'

export interface IDiscountTypeInputProps {
  name: string
}

export const DiscountTypeInput: React.FC<IDiscountTypeInputProps> = ({ name }) => {
  const { currencySymbol } = React.useContext(LocaleContext)

  const options = [
    { key: 0, text: '%', value: false },
    { key: 1, text: currencySymbol, value: true }
  ]

  return <Dropdown name={name} options={options} button basic floating data-testid='discount-type-dropdown' />
}

DiscountTypeInput.displayName = 'DiscountTypeInput'

export default DiscountTypeInput
